import React, { forwardRef } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import { textVariants } from './Text.variants';
import { type TextElement, type TextT } from './Text.types';

export const Text = forwardRef<TextElement, TextT>((props, ref) => {
  const { truncate, className, variant, as = 'span', ...rest } = props;
  const Component = as;
  const textVariantsClasses = textVariants({
    variant,
    truncate: Boolean(truncate),
  });

  return (
    <Component
      {...rest}
      ref={ref}
      className={cn(textVariantsClasses, className)}
    />
  );
});
